<template>
  <div class="users">
    <el-table
      :data="users"
      style="width: 100%"
      empty-text="No users">

      <el-table-column
        prop="name"
        label="Name"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="username"
        label="Username"
        header-align="center">
      </el-table-column>

      <el-table-column
        prop="email"
        label="Email"
        header-align="center"
        class-name="email">
      </el-table-column>

      <el-table-column
        prop="role"
        label="Role"
        header-align="center"
        :formatter="humaniseRole">
      </el-table-column>

      <el-table-column
        v-if="userIsSuperAdmin"
        prop="client_id"
        label="Client"
        header-align="center"
        :formatter="humaniseClient">
      </el-table-column>

      <el-table-column
        label="Operations"
        align="center">
        <template slot-scope="props">
            <operations 
              :id="props.row.id" 
              :disableMore="true"
              @edit="editUser(props.row)" 
              @delete="deleteUser(props.row)">
            </operations>
        </template>
      </el-table-column>
      
    </el-table>
  </div>
</template>

<script>
  import auth from '../../../auth';
  import requests from '../../../requests';

  import operations from '../OpButtons.vue';

  export default {
    name: 'usertable',
    data () {
      return {
        users:[],
        clients:[],
        userIsSuperAdmin: false,
      }
    },
    beforeMount(){
      var profile = JSON.parse(auth.getProfile());
      this.userIsSuperAdmin = (profile.role === 3);
      // this.userIsSuperAdmin = true;

      this.getUsers();
    },
    methods: {
      getUsers(){
        this.users = [];
        var context = this;

        if(this.userIsSuperAdmin) {
          requests.getAllUsers(this, function(result){
            context.users = result.data;

            requests.getAllClients(context, function(result){
              if(result.action === 'success'){
                context.clients = result.data;
              }
            });
          });
        } else {
          var profile = JSON.parse(auth.getProfile());
          requests.getAllUsersForClient(this, profile.client_id, function(result) {
            console.log(result);
            if(result.action == 'success') {
              context.users = result.data.filter(user => user.role != 3);
            }
          });
        }        
      },
      editUser(userData) {
        this.$emit('editUser', userData);
      },
      deleteUser(row) {
        this.$emit('deleteUser', row.id);
      },
      humaniseRole(row, column) {
        var roles = ["General", "Booking", "Admin", "Super Admin"];
        return roles[parseInt(row.role)];
      },
      humaniseClient(row, column) {
        for (var i = 0; i < this.clients.length; i++) {
          var client = this.clients[i];
          if(client.id === row.client_id) {
            return client.name;
          }
        }
        return row.client_id
      },
    },
    components: {
      'operations': operations
    }
  }
  

</script>

<style>
  .el-table .cell {
    word-break: normal !important;
  }

</style>




// WEBPACK FOOTER //
// UserTable.vue?3d00f635